(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mfh-cookie-preferences"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-mfh-cookie-preferences]');
  if (!button || button.disabled) return;
  const status = button.parentElement.querySelector('[data-mfh-cookie-status]');
  status.hidden = true;
  button.disabled = true;
  try {
    if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Preferences unavailable');
    await window.privacyBanner.showPreferences();
  } catch {
    status.hidden = false;
  } finally {
    button.disabled = false;
  }
});
  } catch(e) { console.error(e); }
})();

})();
